"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeNotecardSuccessRate = exports.serializeNotecardSuccessRate = void 0;
const luxon_1 = require("luxon");
const mapSerialization_1 = require("../utils/mapSerialization");
const serializeNotecardSuccessRate = (notecardSuccessRate) => {
    return {
        serializedNotecardHistoryMap: (0, mapSerialization_1.serializeMap)(notecardSuccessRate.notecardHistoryMap),
        startDate: notecardSuccessRate.startDate.toJSDate(),
    };
};
exports.serializeNotecardSuccessRate = serializeNotecardSuccessRate;
const deserializeNotecardSuccessRate = (serializedNotecardSuccessRate) => {
    return {
        notecardHistoryMap: (0, mapSerialization_1.deserializeMap)(serializedNotecardSuccessRate.serializedNotecardHistoryMap),
        startDate: luxon_1.DateTime.fromJSDate(new Date(serializedNotecardSuccessRate.startDate)),
    };
};
exports.deserializeNotecardSuccessRate = deserializeNotecardSuccessRate;
//# sourceMappingURL=notecardSuccessRate.js.map